import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { StateWithoutError } from '#src/app/shared/utils/async';

type GeoFieldsEnabledState = StateWithoutError<{ enabled: boolean }>;

export function useGeoFieldsEnabled(): GeoFieldsEnabledState {
	const {
		data: {
			featureConfigs: { geoFieldsEnabled },
		},
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		return { status: 'loaded', enabled: geoFieldsEnabled };
	}, [geoFieldsEnabled]);
}
